// Internal Route state -----------------------------------------------------------------

type Route = {
  name: string;
  route: string;
};

// External Route state -----------------------------------------------------------------

export enum RouteFields {
  "About" = "about",
  "AuthReset" = "auth-reset",
  "Authorisations" = "authorisations",
  "Companies" = "companies",
  "Countries" = "countries",
  "Dashboard" = "dashboard",
  "Forgot" = "forgot",
  "Home" = "home",
  "Maps" = "maps",
  "Multifactor" = "multifactor",
  "Placeholder" = "placeholder",
  "Products" = "products",
  "Profile" = "profile",
  "SignIn" = "signin",
  "SignInTotp" = "signin-totp",
  "SignUp" = "signup",
  "States" = "states",
  "TimeZones" = "time-zones",
  "Waiting" = "waiting",
}

export enum RouteApis {
  "oauth" = "/oauth",
  "recovery" = "/recovery",
  "signup" = "/signup",
}

// Declare the route exported const, enum and interface values.

export const RouteNames: Record<string, Route> = {
  [RouteFields.About]: { name: "About", route: "/about" },
  [RouteFields.AuthReset]: {
    name: "Authorisations",
    route: "/dashboard",
  },
  [RouteFields.Authorisations]: {
    name: "Authorisations",
    route: "/authorisations",
  },
  [RouteFields.Companies]: { name: "Companies", route: "/companies" },
  [RouteFields.Countries]: { name: "Countries", route: "/countries" },
  [RouteFields.Dashboard]: { name: "Dashboard", route: "/dashboard" },
  [RouteFields.Forgot]: { name: "Forgot", route: "/forgot" },
  [RouteFields.Home]: { name: "Home", route: "/" },
  [RouteFields.Maps]: { name: "Maps", route: "/maps" },
  [RouteFields.Multifactor]: { name: "Multifactor", route: "/multifactor" },
  [RouteFields.Placeholder]: { name: "Placeholder", route: "#" },
  [RouteFields.Products]: { name: "Products", route: "/products" },
  [RouteFields.Profile]: { name: "Profile", route: "/profile" },
  [RouteFields.SignInTotp]: { name: "Sign In Totp", route: "/signin-totp" },
  [RouteFields.SignIn]: { name: "Sign In", route: "/signin" },
  [RouteFields.SignUp]: { name: "Sign Up", route: "/signup" },
  [RouteFields.States]: { name: "States", route: "/states" },
  [RouteFields.TimeZones]: { name: "Time Zones", route: "/time-zones" },
  [RouteFields.Waiting]: { name: "Waiting", route: "/waiting" },
};

export const RouteNamesPrivate: string[] = [
  RouteNames[RouteFields.About].route,
  RouteNames[RouteFields.Authorisations].route,
  RouteNames[RouteFields.Companies].route,
  RouteNames[RouteFields.Countries].route,
  RouteNames[RouteFields.Dashboard].route,
  RouteNames[RouteFields.Maps].route,
  RouteNames[RouteFields.Multifactor].route,
  RouteNames[RouteFields.Products].route,
  RouteNames[RouteFields.Profile].route,
  RouteNames[RouteFields.States].route,
  RouteNames[RouteFields.TimeZones].route,
];

export const RouteNamesPublic: string[] = [
  RouteNames[RouteFields.Forgot].route,
  RouteNames[RouteFields.SignIn].route,
  RouteNames[RouteFields.SignUp].route,
  RouteNames[RouteFields.Waiting].route,
];

export const RouteNamesProtected: string[] = [
  ...RouteNamesPrivate,
  ...RouteNamesPublic,
];
